import { Button, Input, Modal, message } from "antd";
import React, { useEffect, useState } from "react";
import { UserWatchlistApi } from "./UserWatchlistApi";
import "./UserHoldingsPage.css";

const RECT_BTN = "user-holdings-rect-modal-btn";
const WATCHLIST_GROUP_NAME_MAX = 6;

/** 添加分组弹窗（工具栏 / 添加自选内复用） */
export function WatchlistCreateGroupModal(props: {
  open: boolean;
  spaceId: string;
  onClose: () => void;
  onCreated?: (newGroupId: string) => void;
  onAfterListRefresh?: () => void | Promise<void>;
}): JSX.Element {
  const { open, spaceId, onClose, onCreated, onAfterListRefresh } = props;
  const [name, setName] = useState("");
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (open) {
      setName("");
    }
  }, [open]);

  const submit = async () => {
    const n = name.trim();
    if (!n) {
      message.warning("请输入分组名称");
      throw new Error("cancel");
    }
    setCreating(true);
    try {
      const r = await UserWatchlistApi.createGroup(spaceId, n);
      if (r?.rows?.length) {
        message.success("已创建分组");
        const sorted = [...r.rows].sort((a, b) => (b.sortOrder ?? 0) - (a.sortOrder ?? 0));
        const newest = sorted[0];
        if (newest?.id && onCreated) {
          onCreated(String(newest.id));
        }
        await onAfterListRefresh?.();
        onClose();
      } else {
        throw new Error("cancel");
      }
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal
      title="添加分组"
      open={open}
      okText="确认"
      cancelText="取消"
      okButtonProps={{
        className: RECT_BTN,
        style: { width: 120 },
        loading: creating,
      }}
      cancelButtonProps={{ className: RECT_BTN, style: { width: 120 } }}
      onCancel={onClose}
      onOk={() => submit()}
      destroyOnClose
      className="uh-add-watch-modal"
    >
      <Input
        placeholder={`分组名称，最多${WATCHLIST_GROUP_NAME_MAX}个字`}
        maxLength={WATCHLIST_GROUP_NAME_MAX}
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="user-holding-input"
      />
    </Modal>
  );
}
